// extracted by mini-css-extract-plugin
export default {"minhaLista":"MinhaLista_minhaLista__Q696Q"};